import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const AdminCampaignEditor = lazy(() => import("@/pages/admin/AdminCampaignEditor"));

export const Route = createFileRoute("/admin/kampanj/$campaignId")({
  validateSearch: (search: Record<string, unknown>) => ({
    offer: typeof search['offer'] === "string" ? (search['offer'] as string) : undefined,
  }),
  component: () => <AdminCampaignEditor />,
});
